import * as actionTypes from '../types/tn';

export function modalTNOpen(payload) {
  return {
    type: actionTypes.MODAL_TN_OPEN,
    payload
  };
}

export function modalTNClose() {
  return {
    type: actionTypes.MODAL_TN_CLOSE
  };
}

export function setDateTNField(payload) {
  return {
    type: actionTypes.SET_DATE_TN,
    payload
  };
}

export function modalVehicleOpen(payload) {
  return {
    type: actionTypes.MODAL_VEHICLE_OPEN,
    payload
  };
}

export function modalVehicleClose() {
  return {
    type: actionTypes.MODAL_VEHICLE_CLOSE
  };
}

export function getVehiclesList(payload) {
  return {
    type: actionTypes.GET_VEHICLES_LIST,
    payload
  };
}

export function getVehiclesListSuccess(payload) {
  return {
    type: actionTypes.GET_VEHICLES_LIST_SUCCESS,
    payload
  };
}

export function getVehiclesListFail() {
  return {
    type: actionTypes.GET_VEHICLES_LIST_FAIL
  };
}

export function modalVehicleAddOpen() {
  return {
    type: actionTypes.MODAL_VEHICLE_ADD_OPEN
  };
}

export function modalVehicleAddClose() {
  return {
    type: actionTypes.MODAL_VEHICLE_ADD_CLOSE
  };
}

export function addVehicle(payload) {
  return {
    type: actionTypes.ADD_VEHICLE,
    payload
  };
}

export function addVehicleSuccess() {
  return {
    type: actionTypes.ADD_VEHICLE_SUCCESS
  };
}

export function addVehicleFail() {
  return {
    type: actionTypes.ADD_VEHICLE_FAIL
  };
}

export function setVehicleForm(payload) {
  return {
    type: actionTypes.SET_VEHICLE_FORM,
    payload
  };
}

export function modalDriversOpen() {
  return {
    type: actionTypes.MODAL_DRIVERS_OPEN
  };
}

export function modalDriverClose() {
  return {
    type: actionTypes.MODAL_DRIVERS_CLOSE
  };
}

export function modalAddDriverOpen() {
  return {
    type: actionTypes.MODAL_ADD_DRIVER_OPEN
  };
}

export function modalAddDriverClose() {
  return {
    type: actionTypes.MODAL_ADD_DRIVER_CLOSE
  };
}

export function getDriversList(payload) {
  return {
    type: actionTypes.GET_DRIVERS_LIST,
    payload
  };
}

export function getDriversListSuccess(payload) {
  return {
    type: actionTypes.GET_DRIVERS_LIST_SUCCESS,
    payload
  };
}

export function getDriversListFail(payload) {
  return {
    type: actionTypes.GET_DRIVERS_LIST_FAIL,
    payload
  };
}

export function addDriver(payload) {
  return {
    type: actionTypes.ADD_DRIVER,
    payload
  };
}

export function addDriverSuccess() {
  return {
    type: actionTypes.ADD_DRIVER_SUCCESS
  };
}

export function addDriverFail() {
  return {
    type: actionTypes.ADD_DRIVER_FAIL
  };
}

export function setDriverForm(payload) {
  return {
    type: actionTypes.SET_DRIVER_FORM,
    payload
  };
}

export function modalPackingTypeOpen() {
  return {
    type: actionTypes.MODAL_PACKING_TYPE_OPEN
  };
}

export function modalPackingTypeClose() {
  return {
    type: actionTypes.MODAL_PACKING_TYPE_CLOSE
  };
}

export function modalAddPackingTypeOpen() {
  return {
    type: actionTypes.MODAL_ADD_PACKING_TYPE_OPEN
  };
}

export function modalAddPackingTypeClose() {
  return {
    type: actionTypes.MODAL_ADD_PACKING_TYPE_CLOSE
  };
}

export function getPackingTypeList(payload) {
  return {
    type: actionTypes.GET_PACKING_TYPE_LIST,
    payload
  };
}

export function getPackingTypeListSuccess(payload) {
  return {
    type: actionTypes.GET_PACKING_TYPE_LIST_SUCCESS,
    payload
  };
}

export function getPackingTypeListFail() {
  return {
    type: actionTypes.GET_PACKING_TYPE_LIST_FAIL
  };
}

export function addPackingType(payload) {
  return {
    type: actionTypes.ADD_PACKING_TYPE,
    payload
  };
}

export function addPackingTypeSuccess() {
  return {
    type: actionTypes.ADD_PACKING_TYPE_SUCCESS
  };
}

export function addPackingTypeFail() {
  return {
    type: actionTypes.ADD_PACKING_TYPE_FAIL
  };
}

export function setPackingTypeForm(payload) {
  return {
    type: actionTypes.SET_PACKING_TYPE_FORM,
    payload
  };
}

export function saveTn(payload) {
  return {
    type: actionTypes.SAVE_TN,
    payload
  };
}

export function saveTnSuccess(payload) {
  return {
    type: actionTypes.SAVE_TN_SUCCESS,
    payload
  };
}

export function saveTnFail() {
  return {
    type: actionTypes.SAVE_TN_FAIL
  };
}

export function setNote(payload) {
  return {
    type: actionTypes.SET_NOTE_TN,
    payload
  };
}

export function setSavedData(payload){
  return {
    type: actionTypes.SET_SAVED_DATA,
    payload
  };
}

export function setNumberTn(payload) {
  return {
    type: actionTypes.SET_NUMBER_TN,
    payload
  };
}

export function modalTnListOpen() {
  return {
    type: actionTypes.MODAL_TN_LIST_OPEN
  };
}

export function modalTnListClose() {
  return {
    type: actionTypes.MODAL_TN_LIST_CLOSE
  };
}

export function getTnList(payload) {
  return {
    type: actionTypes.GET_TN_LIST,
    payload
  };
}

export function getTnListSuccess(payload) {
  return {
    type: actionTypes.GET_TN_LIST_SUCCESS,
    payload
  };
}

export function getTnListFail() {
  return {
    type: actionTypes.GET_TN_LIST_FAIL
  };
}

export function setTn(payload) {
  return {
    type: actionTypes.SET_TN,
    payload
  };
}

export function setTnSuccess(payload) {
  return {
    type: actionTypes.SET_TN_SUCCESS,
    payload
  };
}

export function getTnPieceList(payload) {
  return {
    type: actionTypes.GET_TN_PIECE_LIST,
    payload
  };
}

export function getTnPieceListSuccess(payload) {
  return {
    type: actionTypes.GET_TN_PIECE_LIST_SUCCESS,
    payload
  };
}

export function getTnPieceListFail() {
  return {
    type: actionTypes.GET_TN_PIECE_LIST_FAIL
  };
}

export function addPieceToTn(payload) {
  return {
    type: actionTypes.ADD_PIECE_TO_TN,
    payload
  };
}

export function addPieceToTnSuccess() {
  return {
    type: actionTypes.ADD_PIECE_TO_TN_SUCCESS
  };
}

export function addPieceToTnFail() {
  return {
    type: actionTypes.ADD_PIECE_TO_TN_FAIL
  };
}

export function deletePieceFromTn(payload) {
  return {
    type: actionTypes.DELETE_PIECE_FROM_TN,
    payload
  };
}

export function deletePieceFromTnSuccess() {
  return {
    type: actionTypes.DELETE_PIECE_FROM_TN_SUCCESS
  };
}

export function deletePieceFromTnFail() {
  return {
    type: actionTypes.DELETE_PIECE_FROM_TN_FAIL
  };
}

export function updateTn(payload) {
  return {
    type: actionTypes.UPDATE_TN,
    payload
  };
}

export function updateTnSuccess(payload) {
  return {
    type: actionTypes.UPDATE_TN_SUCCESS,
    payload
  };
}

export function updateTnFail() {
  return {
    type: actionTypes.UPDATE_TN_FAIL
  };
}

export function confirmTn(payload) {
  return {
    type: actionTypes.CONFIRM_TN,
    payload
  };
}

export function confirmTnSuccess() {
  return {
    type: actionTypes.CONFIRM_TN_SUCCESS
  };
}

export function confirmTnFail() {
  return {
    type: actionTypes.CONFIRM_TN_FAIL
  };
}

export function getTnListUpdate() {
  return {
    type: actionTypes.GET_TN_LIST_UPDATE
  };
}

export function deleteTn(payload) {
  return {
    type: actionTypes.DELETE_TN,
    payload
  };
}

export function deleteTnSuccess() {
  return {
    type: actionTypes.DELETE_TN_SUCCESS
  };
}

export function deleteTnFail() {
  return {
    type: actionTypes.DELETE_TN_FAIL
  };
}

export function getTtnNextNumber(payload) {
  return {
    type: actionTypes.GET_TTN_NEXT_NUMBER,
    payload
  };
}

export function getTtnNextNumberSuccess(payload) {
  return {
    type: actionTypes.GET_TTN_NEXT_NUMBER_SUCCESS,
    payload
  };
}

export function getTtnNextNumberFail() {
  return {
    type: actionTypes.GET_TTN_NEXT_NUMBER_FAIL
  };
}

export function delTtnNextNumber(payload) {
  return {
    type: actionTypes.DEL_TTN_NEXT_NUMBER,
    payload
  };
}

export function getTransportCompanyList(payload) {
  return {
    type: actionTypes.GET_TRANSPORT_COMPANY_LIST,
    payload
  };
}

export function getTransportCompanyListSuccess(payload) {
  return {
    type: actionTypes.GET_TRANSPORT_COMPANY_LIST_SUCCESS,
    payload
  };
}

export function getTransportCompanyListFail() {
  return {
    type: actionTypes.GET_TRANSPORT_COMPANY_LIST_FAIL
  };
}

export function addTransportCompany(payload) {
  return {
    type: actionTypes.ADD_TRANSPORT_COMPANY,
    payload
  };
}

export function addTransportCompanySuccess(payload) {
  return {
    type: actionTypes.ADD_TRANSPORT_COMPANY_SUCCESS,
    payload
  };
}

export function addTransportCompanyFail() {
  return {
    type: actionTypes.ADD_TRANSPORT_COMPANY_FAIL
  };
}

export function modalTransportCompanyOpen() {
  return {
    type: actionTypes.MODAL_TRANSPORT_COMPANY_OPEN
  };
}

export function modalTransportCompanyClose() {
  return {
    type: actionTypes.MODAL_TRANSPORT_COMPANY_CLOSE
  };
}

export function modalTransportCompanyAddOpen() {
  return {
    type: actionTypes.MODAL_TRANSPORT_COMPANY_ADD_OPEN
  };
}

export function modalTransportCompanyAddClose() {
  return {
    type: actionTypes.MODAL_TRANSPORT_COMPANY_ADD_CLOSE
  };
}

export function setIsExpeditorField(payload) {
  return {
    type: actionTypes.SET_IS_EXPEDITOR,
    payload
  };
}

export function setSeparationWeightField(payload) {
  return {
    type: actionTypes.SET_SEPARATION_WEIGHT,
    payload
  };
}

export function setTransportCompanyForm(payload) {
  return {
    type: actionTypes.SET_TRANSPORT_COMPANY_FORM,
    payload
  };
}

export function getResponsiblePersonList(payload) {
  return {
    type: actionTypes.GET_RESPONSIBLE_PERSON_LIST,
    payload
  };
}

export function getResponsiblePersonListSuccess(payload) {
  return {
    type: actionTypes.GET_RESPONSIBLE_PERSON_LIST_SUCCESS,
    payload
  };
}

export function getResponsiblePersonListFail() {
  return {
    type: actionTypes.GET_RESPONSIBLE_PERSON_LIST_FAIL
  };
}

export function addResponsiblePersonTn(payload) {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON_TN,
    payload
  };
}

export function addResponsiblePersonTnSuccess(payload) {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON_TN_SUCCESS,
    payload
  };
}

export function addResponsiblePersonTnFail() {
  return {
    type: actionTypes.ADD_RESPONSIBLE_PERSON_TN_FAIL
  };
}

export function setResponsiblePersonForm(payload) {
  return {
    type: actionTypes.SET_RESPONSIBLE_PERSON_FORM,
    payload
  };
}

export function setSupportingDocumentsForm(payload) {
  return {
    type: actionTypes.SET_SUPPORTING_DOCUMENTS,
    payload
  };
}

export function modalResponsiblePersonOpen() {
  return {
    type: actionTypes.MODAL_RESPONSIBLE_PERSON_OPEN
  };
}

export function modalResponsiblePersonClose() {
  return {
    type: actionTypes.MODAL_RESPONSIBLE_PERSON_CLOSE
  };
}

export function modalResponsiblePersonAddOpen() {
  return {
    type: actionTypes.MODAL_RESPONSIBLE_PERSON_ADD_OPEN
  };
}

export function modalResponsiblePersonAddClose() {
  return {
    type: actionTypes.MODAL_RESPONSIBLE_PERSON_ADD_CLOSE
  };
}

export function setTrailerForm(payload) {
  return {
    type: actionTypes.SET_TRAILER_FORM,
    payload
  };
}

export function deleteEntity(payload) {
  return {
    type: actionTypes.DELETE_ENTITY,
    payload
  };
}

export function deleteEntitySuccess() {
  return {
    type: actionTypes.DELETE_ENTITY_SUCCESS
  };
}

export function deleteEntityFail() {
  return {
    type: actionTypes.DELETE_ENTITY_FAIL
  };
}

export function setInitialStateTn() {
  return {
    type: actionTypes.SET_INITIAL_STATE_TN
  };
}
